"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3486],{

/***/ 91111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31065);
/* harmony import */ var _acko_tech_building_blocks_ui_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2518);
/* harmony import */ var src_common_utils_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79354);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25935);





var Index = function(param) {
    var _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _label = param.label, label = _label === void 0 ? "" : _label, _image = param.image, image = _image === void 0 ? src_common_utils_config__WEBPACK_IMPORTED_MODULE_3__/* .ASSETS.LOADER */ .ou.LOADER : _image, handleClick = param.handleClick, _marginTop = param.marginTop, marginTop = _marginTop === void 0 ? "24px" : _marginTop, _position = param.position, position = _position === void 0 ? "" : _position, _bottom = param.bottom, bottom = _bottom === void 0 ? "" : _bottom, _width = param.width, width = _width === void 0 ? "" : _width, _marginLeft = param.marginLeft, marginLeft = _marginLeft === void 0 ? "" : _marginLeft, _secondary = param.secondary, secondary = _secondary === void 0 ? false : _secondary;
    var Button = secondary ? _acko_tech_building_blocks_ui_button__WEBPACK_IMPORTED_MODULE_2__.SecondaryButton : _acko_tech_building_blocks_ui_button__WEBPACK_IMPORTED_MODULE_2__.PrimaryButton;
    var styles = secondary ? {} : {
        border: "1px solid rgb(15, 164, 87)",
        borderRadius: "8px",
        background: "rgb(15, 164, 87)"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_styles__WEBPACK_IMPORTED_MODULE_1__/* .ButtonContainer */ .qO, {
        marginLeft: marginLeft,
        marginTop: marginTop,
        position: position,
        bottom: bottom,
        width: width,
        styles: disabled || Button === _acko_tech_building_blocks_ui_button__WEBPACK_IMPORTED_MODULE_2__.PrimaryButton ? {} : styles,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_styles__WEBPACK_IMPORTED_MODULE_1__/* .ButtonLoaderImage */ .Ts, {
                src: image,
                marginTop: marginTop,
                visibility: isLoading
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(Button, {
                isFullWidth: true,
                onClick: handleClick,
                disabled: disabled,
                className: "secondary-button",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_styles__WEBPACK_IMPORTED_MODULE_1__/* .ButtonText */ .oD, {
                    padding: "4px 0px",
                    hide: isLoading,
                    children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(label)
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Index);


/***/ }),

/***/ 34349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);

var Index = function(param) {
    var _color = param.color, color = _color === void 0 ? "none" : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.20937 1.5C5.19837 1.5 1.94681 4.74146 1.94681 8.74C1.94681 12.7385 5.19837 15.98 9.20937 15.98C13.2204 15.98 16.4719 12.7385 16.4719 8.74C16.4719 4.74146 13.2204 1.5 9.20937 1.5ZM0.442139 8.74C0.442139 3.91303 4.36736 0 9.20937 0C14.0514 0 17.9766 3.91303 17.9766 8.74C17.9766 13.567 14.0514 17.48 9.20937 17.48C4.36736 17.48 0.442139 13.567 0.442139 8.74Z",
                fill: color
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.5105 6.51086L6.97327 12.0309L5.9093 10.9702L11.4465 5.4502L12.5105 6.51086Z",
                fill: color
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4465 12.0309L5.9093 6.51086L6.97327 5.4502L12.5105 10.9702L11.4465 12.0309Z",
                fill: color
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Index);


/***/ }),

/***/ 3486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22934);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25935);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40706);
/* harmony import */ var src_common_utils_responsive__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7010);
/* harmony import */ var _acko_tech_building_blocks_ui_modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75251);
/* harmony import */ var _acko_tech_building_blocks_ui_modal__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_acko_tech_building_blocks_ui_modal__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var src_common_utils_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79354);
/* harmony import */ var src_international_insurance_components_bundled_plan_assets_cross__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34349);
/* harmony import */ var src_common_components_button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91111);
/* harmony import */ var src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19659);
/* eslint-disable @next/next/no-img-element */ 











var Index = function(param) {
    var sendCustomEvent = param.sendCustomEvent;
    var ref;
    var isMobile = (0,src_common_utils_responsive__WEBPACK_IMPORTED_MODULE_5__/* .useViewport */ .S)().isMobile;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), openModal = ref1[0], setOpenModal = ref1[1];
    var usp_section = _config__WEBPACK_IMPORTED_MODULE_4__/* .LANDING_PAGE_DATA.usp_section */ .BF.usp_section, comparison_section = _config__WEBPACK_IMPORTED_MODULE_4__/* .LANDING_PAGE_DATA.comparison_section */ .BF.comparison_section;
    var renderComparisonModal = function() {
        var ref;
        var isMobile = (0,src_common_utils_responsive__WEBPACK_IMPORTED_MODULE_5__/* .useViewport */ .S)().isMobile;
        var Modal = isMobile ? _acko_tech_building_blocks_ui_modal__WEBPACK_IMPORTED_MODULE_6__.ModalMobile : _acko_tech_building_blocks_ui_modal__WEBPACK_IMPORTED_MODULE_6__.ModalDesktop;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(Modal, {
            show: openModal,
            onHide: function() {
                return setOpenModal(false);
            },
            wrapperStyles: "border-radius: 24px 24px 0px 0px;",
            showOverlayBackground: true,
            urlhash: "",
            header: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().modalTitle),
                children: comparison_section.title
            }),
            hideCloseButton: true,
            padding: "32px 28px 20px 28px",
            minWidth: isMobile ? "" : "400px",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().comparisonModal),
                    children: comparison_section === null || comparison_section === void 0 ? void 0 : (ref = comparison_section.list) === null || ref === void 0 ? void 0 : ref.map(function(item, i) {
                        var ref;
                        var isFirst = i === 0;
                        var isLast = i === (comparison_section === null || comparison_section === void 0 ? void 0 : (ref = comparison_section.list) === null || ref === void 0 ? void 0 : ref.length) - 1;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().listItem),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().title),
                                    children: item
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().statsContainer),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().ackoStats),
                                            style: {
                                                borderRadius: isFirst ? "10px 0 0 0" : isLast ? "0 0 0 10px" : "",
                                                borderTop: isFirst ? "1px solid rgb(239, 233, 251)" : "",
                                                borderBottom: isLast ? "1px solid rgb(239, 233, 251)" : ""
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                    src: src_common_utils_config__WEBPACK_IMPORTED_MODULE_7__/* .COMPLIANCE_PENDING_ICONS.TICK_STAGE */ .kR.TICK_STAGE,
                                                    height: "18px",
                                                    width: "18px"
                                                }),
                                                isFirst && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().ackoLogo),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("img", {
                                                        src: src_common_utils_config__WEBPACK_IMPORTED_MODULE_7__/* .ASSETS.ACKO_LOGO_DARK */ .ou.ACKO_LOGO_DARK,
                                                        width: "70px",
                                                        height: "auto",
                                                        alt: "acko-logo"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().otherStats),
                                            style: {
                                                borderRadius: isFirst ? "0 10px 0 0" : isLast ? "0 0 10px 0" : "",
                                                borderTop: isFirst ? "1px solid rgb(224, 224, 232)" : "",
                                                borderBottom: isLast ? "1px solid rgb(224, 224, 232)" : ""
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(src_international_insurance_components_bundled_plan_assets_cross__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                    color: "#040222"
                                                }),
                                                isFirst && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().otherTag),
                                                    children: "Others"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().modalButton),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(src_common_components_button__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        marginTop: "24px",
                        handleClick: function() {
                            setOpenModal(false);
                        },
                        label: comparison_section === null || comparison_section === void 0 ? void 0 : comparison_section.button_text
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("section", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().uspSection),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().sectionTitle),
                children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(isMobile ? usp_section === null || usp_section === void 0 ? void 0 : usp_section.title : usp_section === null || usp_section === void 0 ? void 0 : usp_section.desktop_title)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().uspCards),
                children: usp_section === null || usp_section === void 0 ? void 0 : (ref = usp_section.cards) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                    var icon_url = param.icon_url, title = param.title, subtitle = param.subtitle;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().uspCard),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: icon_url,
                                height: "60px",
                                width: "60px"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().cardTitle),
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().cardSubtitle),
                                children: subtitle
                            })
                        ]
                    }, title);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().seeMoreAction),
                onClick: function() {
                    setOpenModal(true);
                    sendCustomEvent({}, src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_10__/* .TravelInsuranceViewEvents.VIEW_OTHER_PLANS_COMPARISON */ .e2.VIEW_OTHER_PLANS_COMPARISON);
                },
                children: usp_section === null || usp_section === void 0 ? void 0 : usp_section.see_more_text
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().comparisonSection),
                children: renderComparisonModal()
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ })

}]);